module.exports = __webpack_public_path__ + "img/jzt.6154c1c4.png";